 
export { disable, enable, setLoading, resetForm };

function disable(...fields) {
  fields.forEach((field) => {
    field.disabled = true; 
  });
}

function enable(...fields) {
  fields.forEach((field) => {
    field.disabled = false; 
  });
}

function reset(...fields) {
  fields.forEach((field) => {
    if (field.name === "menge") {
      field.value = 1;
    } else {
      field.value = "";
    }
  });
}

function setLoading(button, loading) {
  if (loading) {
    button.dataset.loading = true;
  } else {
    delete button.dataset.loading;
  }
}

function resetForm(warenkorbButton, ...fields) {
  setTimeout(() => {
    reset(...fields);
    enable(...fields);
    setLoading(warenkorbButton, false);
  }, 1000);
}